<ng-container>
  <div class="list-wrap">
    <ul class="d-list" *ngIf="{activeID: (activeID$ | async)} as streams$">
      <li
        *ngFor="let item of (list$ | async); index as inx"
        intDropdownAreaItem
        [isActive]="streams$.activeID === inx"
        [tabindex]="tabindex"
        class="d-list__item"
        [class.is-active]="streams$.activeID === inx"
        [class.is-select]="isSelected(item.value)"
      >
        <span>
          <ng-content select="left-position"></ng-content>
        </span>
        <ng-container *ngIf="!isTemplateExist">
          <button
            (click)="onSelectItem(item, inx)"
            class="d-list__content"
          >{{ item.label }}</button>
        </ng-container>
        <ng-container *ngIf="isTemplateExist">
          <span class="d-list__content">
            <ng-container
              *ngTemplateOutlet="templateRef; context: {
                $implicit: {
                  index: inx,
                  itemData: item,
                  isSelected: isSelected(item.value),
                  onClick: onSelectItem.bind(this)
                }
            }"></ng-container>
          </span>
        </ng-container>
        <span>
          <ng-content select="right-position"></ng-content>
        </span>
      </li>
    </ul>
  </div>
</ng-container>

